import type { Member } from '@/entities/team';
import request from '@/shared/api/request';

export const inviteTeamMembers = ({
  uuid,
  members,
}: {
  uuid: string;
  members: string[];
}): Promise<{ members: Member[] }> =>
  request({
    url: `/teams/${uuid}/invitations/`,
    method: 'POST',
    data: { members },
  });
